export const themes = {
  Ape: {
    name: "Ape",
    colors: {
      text: "#bfcfbb",
      background: "#7c8d76",
      primary: "#a9746e",
      logoBackground: "#344c3d",
      logoText: "#bfcfbb",
      timerText: "#344c3d",
    },
  },
  aqua: {
    name: "Aqua",
    colors: {
      text: "#003f5c",
      background: "#e0f7fa",
      primary: "#00bcd4",
      logoBackground: "#00bcd4",
      logoText: "#e0f7fa",
      timerText: "#00acc1",
    },
  },

  chai: {
    name: "Chai",
    colors: {
      text: "#3E2723",             // espresso brown text
      background: "#E9D8B5",       // creamy chai background
      logoBackground: "#B08968",   // warm cinnamon-brown logo bg
      logoText: "#F3ECE0",         // cream text on logo
      timerText: "#C97C5D",        // terracotta timer highlight
    },
  },
  
  coffee: {
    name: "Coffee",
    colors: {
      text: "#3e2c23",
      background: "#f3e9dc",
      primary: "#a9746e",
      logoBackground: "#a9746e",
      logoText: "#f3e9dc",
      timerText: "#a9746e",
    },
  },

  dark: {
    name: "Dark",
    colors: {
      text: "#d1d0c5",
      background: "#323438",
      primary: "#e2b714",
      logoBackground: "#7f7e85",
      logoText: "#323438",
      timerText: "#585d78",
    },
  },

  maritime: {
    name: "Maritime",
    colors: {
      text: "#000000",
      background: "#5e83ef",
      primary: "#5e83ef",
      logoBackground: "#000000",
      logoText: "#5e83ef",
      timerText: "#b1b1b1",
    },
  },

  mesa: {
    name: "Mesa!",
    colors: {
      text: "#5b0909",
      background: "#91818a",
      primary:'#ce8b53',
      logoBackground: '#5b0909',
      logoText: '#b15030',
      timerText: '#5b0909',
    },
  },
  
  ocean: {
    name: "Ocean",
    colors: {
      text: "#fff",
      background: "#223a5e",
      primary: "#41b3a3",
      logoBackground: "#41b3a3",
      logoText: "#223a5e",
      timerText: "#41b3a3",
    },
  },
  pastel: {
    name: "Pastel",
    colors: {
      text: "#2e2e2e",
      background: "#fdf6f0",
      primary: "#ffc9de",
      logoBackground: "#ffc9de",
      logoText: "#2e2e2e",
      timerText: "#f58f9c",
    },
  },
  sapphire: {
    name: "Sapphire",
    colors: {
      text: "#cbcbcb",
      background: "#584C99",
      primary: "#e0e7ec",
      logoBackground: "#B497BD",
      logoText: "#e0e7ec",
      timerText: "#B497BD",
    },
  },
  shake: {
    name: "Shake",
    colors: {
      text: "#ffbcd8",
      background: "#011936",
      primary: "#7FC29B",
      logoBackground: "#8f508e",
      logoText: "#ffbcd8",
      timerText: "#7FC29B",
    },
  },
  sunset: {
    name: "Sunset",
    colors: {
      text: "#2c1b2f",
      background: "#fcefee",
      primary: "#ff6b6b",
      logoBackground: "#ff6b6b",
      logoText: "#fcefee",
      timerText: "#ff6b6b",
    },
  },


};
